var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "section",
    { staticClass: "modules-wrap" },
    [
      _c(
        "el-table",
        {
          attrs: {
            data: _vm.tableData,
            height: "100%",
            border: true,
            "header-cell-style": { color: "#333333", background: "#EFF6FF" },
          },
        },
        [
          _c("el-table-column", {
            attrs: {
              type: "index",
              align: "center",
              width: "100",
              label: "序号",
            },
          }),
          _c("el-table-column", {
            attrs: { prop: "buyer_name", align: "center", label: "业务员" },
          }),
          _c("el-table-column", {
            attrs: { prop: "number", align: "center", label: "出货件数（件）" },
          }),
          _c("el-table-column", {
            attrs: { prop: "time", align: "center", label: "日期" },
          }),
          _c("el-table-column", {
            attrs: {
              prop: "buyer_category",
              "min-width": "150",
              "show-overflow-tooltip": "",
              align: "center",
              label: "所属品类",
            },
            scopedSlots: _vm._u([
              {
                key: "default",
                fn: function (scope) {
                  return [
                    _c("span", [
                      _vm._v(_vm._s(scope.row.buyer_category || "-")),
                    ]),
                  ]
                },
              },
            ]),
          }),
          _c("el-table-column", {
            attrs: {
              prop: "tonnage_num",
              align: "center",
              label: "出货重量（吨）",
            },
          }),
          _c("el-table-column", {
            attrs: {
              prop: "total_amount",
              align: "center",
              label: "出货额（万元）",
            },
          }),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }